import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  Output,
  EventEmitter,
} from '@angular/core';
import { SearchFieldComponent } from '../../atoms/search-field/search-field.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { Store } from '../../../types';
import { FilterDirectiveDirective } from '../../atoms/filter-directive/filter-directive.directive';
import { StoreService } from '../../../services/store/store.service';
import { catchError, EMPTY, startWith, Subject, switchMap, takeUntil } from 'rxjs';

@Component({
  selector: 'app-store-impersonation-dropdown',
  standalone: true,
  imports: [
    SearchFieldComponent,
    MatMenuModule,
    MatButtonModule,
    FilterDirectiveDirective,
  ],
  templateUrl: './store-impersonation-dropdown.component.html',
  styleUrl: './store-impersonation-dropdown.component.css',
})
export class StoreImpersonationDropdownComponent implements OnInit, OnDestroy {
  private readonly destroyed = new Subject<void>();
  private search = '';
  stores: Store[] = [];
  @Input() showDropDown: boolean = false;
  filteredStores: Store[] = [];
  @Output() storeSelected = new EventEmitter<Store>();

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private storeService: StoreService
  ) {}

  ngOnInit(): void {
    this.storeService.storesChanged$.pipe(
      startWith(undefined),
      switchMap(() => this.storeService.getAllStores().pipe(catchError(() => EMPTY))),
      takeUntil(this.destroyed)
    ).subscribe(stores => {
      this.stores = stores.filter(store => store.isActive)
        .sort((a, b) => a.place.localeCompare(b.place, 'da'));
      this.filterStores(this.search);
    });
  }

  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  }

  filterStores(filterValue: string) {
    this.search = filterValue.trim().toLowerCase();
    filterValue = this.search;
    if (filterValue !== '') {
      this.filteredStores = this.stores.filter(
        (store) =>
          store.place.toLowerCase().includes(filterValue) ||
          store.id.toString().includes(filterValue)
      );
    } else {
      this.filteredStores = this.stores;
    }
    this.changeDetectorRef.markForCheck();
  }

  handleStoreClick(store: Store) {
    this.storeSelected.emit(store);
  }

  onOutsideClick() {
    this.showDropDown = false;
  }
}
